import { Html5Qrcode } from 'html5-qrcode';

export async function safeStopHtml5Qrcode(scanner: Html5Qrcode | null | undefined): Promise<void> {
  if (!scanner) return;

  try {
    if (scanner.isScanning) {
      await scanner.stop();
    }
  } catch {
    //
  }

  try {
    scanner.clear();
  } catch {
    //
  }
}
